// vs player进入游戏前的冲击闪电的过渡页面
import React, {useContext, useEffect, useState} from "react";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import {PageEnum, PageProps} from "../../../../types/IPage.ts";
import './VSPlayerShockingPage.css'
import {IVSPlayerPageProps} from "../../../../types/IVSPlayer.ts";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";

const VSPlayerShockingPage: React.FC<PageProps & IVSPlayerPageProps> = ({currentPage,switchPage,vsPlayerInfo}) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    // 是否显示闪电图标
    const [showLightningIcon, setShowLightningIcon] = useState(false);

    useEffect(() => {
        let timerId: string | number | NodeJS.Timeout | undefined
        setTimeout(() => {
            setShowLightningIcon(true)
        }, 200);

        if (showLightningIcon) {
            timerId = setTimeout(() => {
                switchPage(PageEnum.VS_PLAYER_GAME_PAGE)

            }, 1000);
        } else {
            timerId = setTimeout(() => {
                switchPage(PageEnum.VS_PLAYER_GAME_PAGE)
            }, 2000);
        }
        return () => {
            clearTimeout(timerId); // 清除定时器，避免在组件卸载后执行跳转
        };

    }, [currentPage, showLightningIcon]);

    useEffect(() => {
        // GA 埋点
        GAEvents.createMatchShowInPkPage();
    }, []);


    // 点击取消
    const onClickCancel = () => {
        // GA 埋点
        GAEvents.createMatchCancel();
        // 切换页面
        switchPage(PageEnum.VS_PLAYER_HOME)
    }

    return (
        <div>
            {/*叠加的背景图*/}
            <div className="vs-player-shocking-bg-color"/>
            <div className="common-page-background-img" style={{backgroundImage: `url(${imgUrls.rectangleIcon})`}}/>
            <div className="vs-player-shocking-bg-color-white "/>
            <div className="display-flex-column justify-content-center align-items-center">
                <img className="margin-left-right-auto margin-top-66 width-66 height-66"
                     src={imgUrls.vsPlayWaitingTopIcon} alt="img"/>
                <img className="margin-top-32 width-178  margin-left-right-auto"
                     src={imgUrls.vsPlayShockingTextIcon} alt="img"/>
                {/*挑战加闪电*/}
                <div className="vs-player-shocking-left-right-container">
                    <div
                        className="vs-player-shocking-left-pic display-flex-row slide-in-element-from-left display-flex-align-items-center display-flex-justify-content-center"
                        style={{backgroundImage: `url(${imgUrls.challengeLeftCardUrl})`}}>
                        {/*内容*/}
                        {/*左边*/}
                        <div
                            className="margin-top-bottom-auto margin-left-right-auto display-flex-column display-flex-align-items-center display-flex-align-content">
                            <img className="vs-player-shocking-avatar-img "
                                 src={vsPlayerInfo?.ownerCgtnAvatar ?? imgUrls.defaultAvatarUrl}
                                 alt="avatar"/>
                            <div className="vs-player-shocking-name-title margin-top-14 my-roboto-bold">YOU</div>
                            <div
                                className="vs-player-shocking-name width-131 ellipsis text-center margin-top-3  my-roboto-italic">{vsPlayerInfo?.ownerCgtnName ?? vsPlayerInfo?.ownerGuestName ?? '-'}</div>
                        </div>
                        {showLightningIcon ?
                            <img id="lightingIcon" className="fade-in-animation challenge-lighting-icon"
                                 src={imgUrls.challengeLightingIconUrl}
                                 alt="img"/> : undefined}
                    </div>
                    {/*右边*/}
                    <div className="vs-player-shocking-right-pic slide-in-element"
                         style={{backgroundImage: `url(${imgUrls.challengeRightCardUrl})`}}>
                        <div
                            className="display-flex-column height-100-percent margin-top-bottom-auto display-flex-align-items-center display-flex-justify-content-center">
                            <img className="vs-player-shocking-avatar-img"
                                 src={vsPlayerInfo?.invitedCgtnAvatar ?? imgUrls?.defaultAvatarUrl}
                                 alt="avatar"/>
                            <div className="vs-player-shocking-name-title my-roboto-bold margin-top-14">Opponent</div>
                            <div
                                className="vs-player-shocking-name width-136 ellipsis margin-top-3 text-center  my-roboto-italic">{vsPlayerInfo?.invitedCgtnName ?? vsPlayerInfo?.invitedGuestName ?? '-'}</div>
                        </div>
                    </div>

                </div>

                {/*cancel按钮*/}
                <div onClick={onClickCancel}
                     className="challenge-cancel-btn bg-color-grey margin-left-right-auto my-roboto-medium">Cancel
                </div>

            </div>
        </div>
    );
};

export default VSPlayerShockingPage;